
// need this file. its used an alot of place hard code ?
class AuthenticationHelper {
  static isAuthenticated = false
}

export default AuthenticationHelper
